import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { EncrDecrService } from './encr-decr.service';

@Injectable({
  providedIn: 'root'
})
export class AdsService {

  constructor(private http: HttpClient, private EncDecrService: EncrDecrService) { }

  getPackages() {
    const user = JSON.parse(this.EncDecrService.decryptJsonDataFromStorage('user'));
    var headers_object = new HttpHeaders().set("Authorization", "Bearer " + user.api_token);
    return this.http.get(environment.apiURI + 'package', { headers: headers_object }).toPromise();
  }

  userCreateAd(data) {
    const user = JSON.parse(this.EncDecrService.decryptJsonDataFromStorage('user'));
    var headers_object = new HttpHeaders().set("Authorization", "Bearer " + user.api_token);
    return this.http.post(environment.apiURI + 'user/ads',data, { headers: headers_object }).toPromise();
  }

  getPendingAds(){
    const user = JSON.parse(this.EncDecrService.decryptJsonDataFromStorage('user'));
    var headers_object = new HttpHeaders().set("Authorization", "Bearer " + user.api_token);
    return this.http.get(environment.apiURI + 'admin/ads/pending', { headers: headers_object }).toPromise();
  }

  acceptPendingAd(ad_id, status){
    const user = JSON.parse(this.EncDecrService.decryptJsonDataFromStorage('user'));
    var headers_object = new HttpHeaders().set("Authorization", "Bearer " + user.api_token);
    return this.http.post(environment.apiURI + 'admin/ads/accept', {ad_id: ad_id, status: status}, { headers: headers_object }).toPromise();
  }

  deleltePackage(id){
    const user = JSON.parse(this.EncDecrService.decryptJsonDataFromStorage('user'));
    var headers_object = new HttpHeaders().set("Authorization", "Bearer " + user.api_token);
    return this.http.delete(environment.apiURI + 'package/'+id, { headers: headers_object }).toPromise();
  }

  addPackage(data){
    const user = JSON.parse(this.EncDecrService.decryptJsonDataFromStorage('user'));
    var headers_object = new HttpHeaders().set("Authorization", "Bearer " + user.api_token);
    return this.http.post(environment.apiURI + 'package',data, { headers: headers_object }).toPromise();
  }

  updatePackage(id, data){
    const user = JSON.parse(this.EncDecrService.decryptJsonDataFromStorage('user'));
    var headers_object = new HttpHeaders().set("Authorization", "Bearer " + user.api_token);
    return this.http.put(environment.apiURI + 'package/'+id, data, { headers: headers_object }).toPromise();
  }
  
  getMyCreatedAds(){
    const user = JSON.parse(this.EncDecrService.decryptJsonDataFromStorage('user'));
    var headers_object = new HttpHeaders().set("Authorization", "Bearer " + user.api_token);
    return this.http.get(environment.apiURI + 'user/ads', { headers: headers_object }).toPromise();
  }

}


